import { readerNotes } from "@/pages/home/data";

export default function AboutSection() {
  return (
    <section id="about" className="scroll-anchor bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        {/* 关于 / 理念 */}
        <div className="grid gap-10 lg:grid-cols-12">
          <div className="lg:col-span-7">
            <div className="flex items-center gap-2 text-sm font-bold text-primary-600">
              <span className="h-px w-8 bg-primary-500"></span>
              关于我们
            </div>
            <h2 className="mt-3 font-heading text-2xl font-black leading-tight text-foreground-950 md:text-4xl">
              关于「看吃瓜」：不止看热闹，更看懂门道
            </h2>
            <p className="mt-5 text-[15px] leading-7 text-foreground-700">
              看吃瓜是一个以“深扒”为核心的泛娱乐内容媒体。我们关注娱乐圈动态、综艺幕后、品牌营销与舆论热点，但不满足于搬运标题和消费情绪。
              每一篇内容都围绕事件真相、内幕解析与背后故事展开，用编辑部的方法把零散线索整理成清晰的脉络。
            </p>
            <p className="mt-4 text-[15px] leading-7 text-foreground-700">
              我们坚持“先收集、再排序、最后才表态”的内容原则，倡导理性吃瓜：来源可追溯、证据可核对、结论可纠错。
              我们不刻意制造对立，也不被流量裹挟，只希望在你按下转发之前，替你多问一句：这件事，真的如看起来那样吗？
            </p>

            <ul className="mt-6 grid gap-3 sm:grid-cols-2">
              {[
                { icon: "ri-focus-3-line", t: "溯源第一", d: "每条关键信息尽量标注出处与可信等级" },
                { icon: "ri-collage-line", t: "还原上下文", d: "不掐头去尾，把完整语境交还给读者" },
                { icon: "ri-refund-2-line", t: "可纠错", d: "发现出入及时更正，并同步勘误说明" },
                { icon: "ri-heart-line", t: "克制表达", d: "不把猜测当事实，不消费当事人" },
              ].map((p) => (
                <li key={p.t} className="flex gap-3 rounded-lg bg-background-100 p-4">
                  <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-md bg-accent-100 text-accent-700">
                    <i className={p.icon} aria-hidden="true"></i>
                  </span>
                  <div>
                    <p className="text-sm font-bold text-foreground-950">{p.t}</p>
                    <p className="mt-0.5 text-xs leading-relaxed text-foreground-600">{p.d}</p>
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-5">
            <p className="text-xs font-bold uppercase tracking-widest text-foreground-500">读者口碑</p>
            <div className="mt-4 flex flex-col gap-4">
              {readerNotes.map((r) => (
                <figure key={r.name} className="rounded-lg bg-background-100 p-5">
                  <div className="flex text-accent-500">
                    {Array.from({ length: 5 }).map((_, i) => (
                      <i key={i} className="ri-star-fill text-sm" aria-hidden="true"></i>
                    ))}
                  </div>
                  <blockquote className="mt-3 text-sm leading-7 text-foreground-700">“{r.text}”</blockquote>
                  <figcaption className="mt-4 flex items-center gap-3">
                    <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 font-bold text-primary-600">
                      {r.name.charAt(0)}
                    </span>
                    <div>
                      <p className="text-sm font-bold text-foreground-950">{r.name}</p>
                      <p className="text-xs text-foreground-500">{r.role}</p>
                    </div>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}